import * as React from 'react';
import { useState, useEffect } from 'react';
import Search from './Search';
import Results from './Results';
import { History } from 'history';
import { get as getDatabase, IDatabase, format } from '../../services/database';

export default (props: { history: History, match: { params: { databaseName?: string, accountName?: string } } }) => {
    const [database, setDatabase] = useState<IDatabase | null>(null);

    const loadDatabase = async () => {
        if (props.match.params.databaseName) {
            const databaseResult = await getDatabase(props.match.params.databaseName, props.match.params.accountName);
            if (databaseResult.success) setDatabase(databaseResult.database);
        }
    };

    useEffect(() => {
        loadDatabase();
    }, []);

    return (
        window.location.href.indexOf('?') !== -1 && props.match.params.databaseName && props.match.params.accountName ?
            <Results history={props.history} database={database} databaseName={props.match.params.databaseName} accountName={props.match.params.accountName} /> :
            props.match.params.databaseName && props.match.params.accountName ? <Search history={props.history} database={database} databaseName={props.match.params.databaseName} accountName={props.match.params.accountName} /> : <div>Database not found</div>
    )
};



// WEBPACK FOOTER //
// ./src/public/search/index.tsx